import { useMemo, CSSProperties } from 'react';
import { useTheme } from '@rbx/ui';
import { docco } from 'react-syntax-highlighter/dist/cjs/styles/hljs';

/**
 * Generates syntax highlighting styles based on the current theme
 */
export default function useSyntaxHighlightingStyles() {
  const theme = useTheme();

  return useMemo(() => {
    const styles: Record<string, CSSProperties> = { ...docco };

    styles.hljs = {
      ...styles.hljs,
      background: theme.palette.surface[200],
      color: theme.palette.content.standard,
      padding: 0,
    };

    styles['hljs-subst'] = { color: theme.palette.content.standard };

    switch (theme.palette.mode) {
      case 'light':
        styles['hljs-number'].color = '#936900';
        styles['hljs-string'].color = '#008147';
        styles['hljs-comment'] = { color: '#696A6D' };
        styles['hljs-keyword'].color = '#CF2017';
        styles['hljs-built_in'].color = '#7F0000';
        styles['hljs-name'].color = '#456AD4';
        styles['hljs-title'] = { color: '#456AD4' };
        styles['hljs-params'].color = '#111216';
        styles['hljs-punctuation'] = { color: '#696A6D' };
        styles['hljs-literal'].color = '#CF2017';
        break;
      case 'dark':
      default:
        styles['hljs-number'].color = '#FFC600';
        styles['hljs-string'].color = '#ADF195';
        styles['hljs-comment'] = { color: '#666666' };
        styles['hljs-keyword'].color = '#F86D7C';
        styles['hljs-built_in'].color = '#84D6F7';
        styles['hljs-name'].color = '#61A1F1';
        styles['hljs-title'] = { color: '#61A1F1' };
        styles['hljs-params'].color = '#FFFFFF';
        styles['hljs-punctuation'] = { color: '#CCCCCC' };
        styles['hljs-literal'].color = '#FFC600';
        break;
    }

    return styles;
  }, [theme]);
}
